export const navigation = {
  montessori: "Montessori",
  openHouse: "Dia de Portas Abertas",
  contact: "Contato",
  aboutUs: "Sobre Nós",
  prices: "Preços",
  school: {
    main: "Escola",
    aboutUs: "Sobre Nós",
    montessori: "Educação Montessori",
    trilingual: "Educação Trilíngue"
  },
  schoolLife: {
    main: "Vida Escolar",
    calendar: "Calendário Escolar",
    extracurriculars: "Extracurriculares",
    services: "Serviços"
  },
  admissions: {
    main: "Admissões",
    process: "Processo de Admissão",
    prices: "Preços e Tarifas",
    visit: "Visite a Escola",
    openHouse: "Dia de Portas Abertas"
  },
  activities: {
    main: "Atividades",
    birthdays: "Aniversários",
    easterCamp: "Acampamento Páscoa",
    summerCamp: "Acampamento Verão",
    christmasCamp: "Acampamento Natal",
    courses: "Cursos"
  },
  extracurriculars: "Extracurriculares",
  courses: "Cursos",
  camps: {
    main: "Acampamentos",
    easter: "Páscoa",
    summer: "Verão"
  }
};